module.exports = __webpack_public_path__ + "static/media/thumb-down.5db94d14.svg";